<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex class="text-center" md12>
        <h1 class="header" >Benvenuto in 
        <img v-if="config.host=='egyn'" class="header-logo" src="../assets/egyn-white.svg" />
        <img v-if="config.host=='ebiology'"  class="header-logo" src="../assets/ebiology-white.svg" />
        </h1>
        
        <h2 v-if="config.host=='egyn'" class="sub-header" >Il 1° creatore di siti web per la Ginecologia specialistica</h2>
        <h2 v-if="config.host=='ebiology'"  class="sub-header" >Il 1° creatore di siti web per i Biologi Nutrizionisti</h2>
        <Wizard />
        <div style='height:40px'/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Wizard from "../components/Wizard";
import config from "../config/index";

export default {
  data() {
    return {
      config : config
    };
  },

  components: {
    Wizard,
  },

  mounted() {
    
  }
};
</script>

<style scoped>
.header {
  background-color: #213b52;
  color: white;
  font-weight: 400;
}
.sub-header {
  color: #999999;
  background-color: #74a2bc;
  color: white;
}

.header-logo {
  height: 40px;
}

</style>



